import React, { useState } from 'react';
import styled from 'styled-components';
import { useSelector } from "react-redux";

const Footer = ({ theme, position }) => {
  const open = useSelector((state) => state.open.boolean);

  const [isLinkHovered, setIsLinkHovered] = useState(false);

  const handleLinkMouseOver = () => {
    setIsLinkHovered(true);
  };

  const handleLinkMouseLeave = () => {
    setIsLinkHovered(false);
  };

  return (
    <FooterBox theme={open ? theme : 'white'} position={position}>
      <p onMouseOver={handleLinkMouseOver}
        onMouseLeave={handleLinkMouseLeave}
        className={isLinkHovered ? 'hovered-link' : ''}>서울 특별시 금천구 가산디지털로 121. 에이스 가산타워 1304호
        <span>ⓒ topping All rights reserved</span>
      </p>
      <ul onMouseOver={handleLinkMouseOver}
        onMouseLeave={handleLinkMouseLeave}
        className={isLinkHovered ? 'hovered-link' : ''}>
        <li>
          <p>Contact</p>
          <span>info@topping.io</span>
        </li>
        <li>
          <p>Tel</p>
          <span>010-8310-1639</span>
        </li>
      </ul>
    </FooterBox>
  );
};

const FooterBox = styled.div`
  width: 100%;
  padding:40px 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: ${props => props.position === 'fixed' ? 'fixed' : 'unset'};
  color:${props => props.theme === 'white' ? '#fff' : '#000'};
  left: 0;
  bottom: 0;
  z-index: 10;
  height: 128px ;
  background:${props => props.theme === 'white' ? 'rgba(0, 0, 0, 0.20)' : 'rgba(255, 255, 255, 0.20);'};  
  backdrop-filter: blur(5px);
  p{
    font-size: 14px;
  }
  span{
    margin-top: 10px;
    display: block;
  }
  ul{
    display: flex;
    span{
      font-weight: 600;
    }
    li{
      margin-left:70px;
    }
  }
`;

export default Footer;